"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipartApi = exports.MultipartApiFactory = exports.MultipartApiFp = exports.MultipartApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * MultipartApi - axios parameter creator
 * @export
 */
const MultipartApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Abort multipart upload
         * @param {InputAbortMultipartUpload} [inputAbortMultipartUpload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortMultipartUpload: (inputAbortMultipartUpload, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/multipart/abort`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputAbortMultipartUpload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Complete multipart upload
         * @param {InputCompleteMultipartUpload} [inputCompleteMultipartUpload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeMultipartUpload: (inputCompleteMultipartUpload, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/multipart/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputCompleteMultipartUpload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get multipart upload status
         * @param {string} key
         * @param {string} uploadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultipartUploadStatus: (key, uploadId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            (0, common_1.assertParamExists)('getMultipartUploadStatus', 'key', key);
            // verify required parameter 'uploadId' is not null or undefined
            (0, common_1.assertParamExists)('getMultipartUploadStatus', 'uploadId', uploadId);
            const localVarPath = `/multipart/status/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (uploadId !== undefined) {
                localVarQueryParameter['uploadId'] = uploadId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get multipart upload urls
         * @param {InputGetMultipartUploadUrls} [inputGetMultipartUploadUrls]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultipartUploadUrls: (inputGetMultipartUploadUrls, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/multipart/urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputGetMultipartUploadUrls, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  **Permission required**: [\"create\", \"Folder\"]
         * @summary Start multipart upload | Permission required: [\"create\", \"Folder\"]
         * @param {InputStartMultipartUpload} [inputStartMultipartUpload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMultipartUpload: (inputStartMultipartUpload, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/multipart/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputStartMultipartUpload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MultipartApiAxiosParamCreator = MultipartApiAxiosParamCreator;
/**
 * MultipartApi - functional programming interface
 * @export
 */
const MultipartApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MultipartApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Abort multipart upload
         * @param {InputAbortMultipartUpload} [inputAbortMultipartUpload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortMultipartUpload(inputAbortMultipartUpload, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.abortMultipartUpload(inputAbortMultipartUpload, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Complete multipart upload
         * @param {InputCompleteMultipartUpload} [inputCompleteMultipartUpload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeMultipartUpload(inputCompleteMultipartUpload, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completeMultipartUpload(inputCompleteMultipartUpload, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get multipart upload status
         * @param {string} key
         * @param {string} uploadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultipartUploadStatus(key, uploadId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMultipartUploadStatus(key, uploadId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get multipart upload urls
         * @param {InputGetMultipartUploadUrls} [inputGetMultipartUploadUrls]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultipartUploadUrls(inputGetMultipartUploadUrls, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMultipartUploadUrls(inputGetMultipartUploadUrls, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *  **Permission required**: [\"create\", \"Folder\"]
         * @summary Start multipart upload | Permission required: [\"create\", \"Folder\"]
         * @param {InputStartMultipartUpload} [inputStartMultipartUpload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMultipartUpload(inputStartMultipartUpload, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startMultipartUpload(inputStartMultipartUpload, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.MultipartApiFp = MultipartApiFp;
/**
 * MultipartApi - factory interface
 * @export
 */
const MultipartApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MultipartApiFp)(configuration);
    return {
        /**
         *
         * @summary Abort multipart upload
         * @param {InputAbortMultipartUpload} [inputAbortMultipartUpload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortMultipartUpload(inputAbortMultipartUpload, options) {
            return localVarFp.abortMultipartUpload(inputAbortMultipartUpload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Complete multipart upload
         * @param {InputCompleteMultipartUpload} [inputCompleteMultipartUpload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeMultipartUpload(inputCompleteMultipartUpload, options) {
            return localVarFp.completeMultipartUpload(inputCompleteMultipartUpload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get multipart upload status
         * @param {string} key
         * @param {string} uploadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultipartUploadStatus(key, uploadId, options) {
            return localVarFp.getMultipartUploadStatus(key, uploadId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get multipart upload urls
         * @param {InputGetMultipartUploadUrls} [inputGetMultipartUploadUrls]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultipartUploadUrls(inputGetMultipartUploadUrls, options) {
            return localVarFp.getMultipartUploadUrls(inputGetMultipartUploadUrls, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"create\", \"Folder\"]
         * @summary Start multipart upload | Permission required: [\"create\", \"Folder\"]
         * @param {InputStartMultipartUpload} [inputStartMultipartUpload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMultipartUpload(inputStartMultipartUpload, options) {
            return localVarFp.startMultipartUpload(inputStartMultipartUpload, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MultipartApiFactory = MultipartApiFactory;
/**
 * MultipartApi - object-oriented interface
 * @export
 * @class MultipartApi
 * @extends {BaseAPI}
 */
class MultipartApi extends base_1.BaseAPI {
    /**
     *
     * @summary Abort multipart upload
     * @param {InputAbortMultipartUpload} [inputAbortMultipartUpload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MultipartApi
     */
    abortMultipartUpload(inputAbortMultipartUpload, options) {
        return (0, exports.MultipartApiFp)(this.configuration).abortMultipartUpload(inputAbortMultipartUpload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Complete multipart upload
     * @param {InputCompleteMultipartUpload} [inputCompleteMultipartUpload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MultipartApi
     */
    completeMultipartUpload(inputCompleteMultipartUpload, options) {
        return (0, exports.MultipartApiFp)(this.configuration).completeMultipartUpload(inputCompleteMultipartUpload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get multipart upload status
     * @param {string} key
     * @param {string} uploadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MultipartApi
     */
    getMultipartUploadStatus(key, uploadId, options) {
        return (0, exports.MultipartApiFp)(this.configuration).getMultipartUploadStatus(key, uploadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get multipart upload urls
     * @param {InputGetMultipartUploadUrls} [inputGetMultipartUploadUrls]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MultipartApi
     */
    getMultipartUploadUrls(inputGetMultipartUploadUrls, options) {
        return (0, exports.MultipartApiFp)(this.configuration).getMultipartUploadUrls(inputGetMultipartUploadUrls, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  **Permission required**: [\"create\", \"Folder\"]
     * @summary Start multipart upload | Permission required: [\"create\", \"Folder\"]
     * @param {InputStartMultipartUpload} [inputStartMultipartUpload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MultipartApi
     */
    startMultipartUpload(inputStartMultipartUpload, options) {
        return (0, exports.MultipartApiFp)(this.configuration).startMultipartUpload(inputStartMultipartUpload, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MultipartApi = MultipartApi;
